import { liftString } from '../../stdlib/core/bindings-assemblyscript.js';
import { instantiateWasmModule } from './wasm-helpers.js';

const readMetadata = async (wasmBuffer) => {
    // In order to read metadata, we need to introspect the module to get the imports
    const inputImports = {};
    const wasmModule = WebAssembly.Module.imports(new WebAssembly.Module(wasmBuffer));
    // Then we generate dummy functions to be able to instantiate the module
    wasmModule
        .filter((imprt) => imprt.module === 'input' && imprt.kind === 'function')
        .forEach((imprt) => (inputImports[imprt.name] = () => undefined));
    const wasmInstance = await instantiateWasmModule(wasmBuffer, {
        input: inputImports,
    });
    // Finally, once the module instantiated, we read the metadata
    const rawModule = wasmInstance.exports;
    const stringPointer = rawModule.metadata.valueOf();
    const metadataJSON = liftString(rawModule, stringPointer);
    return JSON.parse(metadataJSON);
};

export { readMetadata };
